"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var iris_1 = require("iris");
function objToQuery(json) {
    return Object.keys(json)
        .map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(json[k]);
    })
        .join('&');
}
var LoadTransportationApi = /** @class */ (function () {
    function LoadTransportationApi() {
        // state defaults
        this.state = {
            loading: false,
        };
        // available actions
        this.actions = {
            // tslint:disable-next-line:cyclomatic-complexity
            'loadTransportation/load': function (_a) {
                var getters = _a.getters, dispatch = _a.dispatch;
                return __awaiter(this, void 0, void 0, function () {
                    var params, response;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                params = createRequest(getters['transportRail/loadTransportParams']);
                                if (!params) return [3 /*break*/, 3];
                                return [4 /*yield*/, iris_1.client.railTransport(params)];
                            case 1:
                                response = _b.sent();
                                return [4 /*yield*/, dispatch('transport/setTransportation', mapToTransport(response))];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        };
        // available mutations
        this.mutations = {
            'loadTransportation/SET_LOADING': function (state, data) {
                state.loading = data;
            },
        };
    }
    return LoadTransportationApi;
}());
exports.LoadTransportationApi = LoadTransportationApi;
// Helper functions
// tslint:disable-next-line:cyclomatic-complexity
function createRequest(data) {
    var request = {
        cruiseID: data.cruiseId,
        adults: data.adults,
        juveniles: data.juveniles,
        children: data.children,
        paxe: getPaxRailInfo(data),
        priceModel: getPriceModel(data.priceModel),
        transClass: data.transClass,
        direction: data.direction,
        transportationType: 'RIT'
    };
    return request;
}
function countDiscount(paxWithDiscount) {
    var countDiscount = 0;
    for (var _i = 0, paxWithDiscount_1 = paxWithDiscount; _i < paxWithDiscount_1.length; _i++) {
        var disc = paxWithDiscount_1[_i];
        if (disc) {
            countDiscount++;
        }
    }
    return countDiscount;
}
function getPriceModel(pm) {
    return pm;
}
function getTransportClass(state) {
    if (state.departure) {
        return state.departureConfig.category;
    }
    if (state.arrival) {
        return state.arrivalConfig.category;
    }
    return '2';
}
// tslint:disable-next-line:cyclomatic-complexity
function getPaxRailInfo(data) {
    var paxInfos = [];
    if (data.birthday0) {
        paxInfos.push({
            birthday: data.birthday0,
        });
    }
    if (data.birthday1) {
        paxInfos.push({
            birthday: data.birthday1,
        });
    }
    if (data.birthday2) {
        paxInfos.push({
            birthday: data.birthday2,
        });
    }
    if (data.birthday3) {
        paxInfos.push({
            birthday: data.birthday3,
        });
    }
    if (data.birthday4) {
        paxInfos.push({
            birthday: data.birthday4,
        });
    }
    return paxInfos;
}
function mapToTransport(railTransports) {
    var transportations = [];
    for (var _i = 0, railTransports_1 = railTransports; _i < railTransports_1.length; _i++) {
        var railTransport = railTransports_1[_i];
        var pricings = {
            Pricing: [],
        };
        var referencePrice = 0;
        for (var _a = 0, _b = railTransport.pricings.Pricing; _a < _b.length; _a++) {
            var pricing = _b[_a];
            pricings.Pricing.push({
                amount: pricing.amount,
                currency: 'EUR',
            });
            referencePrice += parseFloat(pricing.amount);
        }
        transportations.push({
            code: railTransport.code,
            type: 'RIT',
            tariffType: railTransport.transportationSegments[0].tariff,
            direction: railTransport.direction,
            transportationClass: railTransport.transClass,
            pricings: pricings,
            referencePrice: referencePrice,
        });
    }
    return transportations;
    // tslint:disable-next-line:max-file-line-count
}
//# sourceMappingURL=load_transportation.js.map